import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ob-zis',
  templateUrl: './ob-zis.component.html',
  styleUrls: ['./ob-zis.component.scss']
})
export class ObZisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
